{
  "policiesControlWhoAccessMap": "In the <b>Policies</b>, you can control who has access to the map and camera views during an event. Access is restricted by default but can be granted to staff based on your district’s policies. Use tags to assign access carefully, as these views may show sensitive content.",
  "systemGeneratedPolicyCannotModified": "System generated policy cannot be modified",
  "cameraView": "Camera View",
  "mapView": "Map View",
  "talkToAll": "Talk to All",
  "gunCarrier": "Gun Carrier"
}
